export default "__VITE_ASSET__Cg9bxI1g__"